export default __webpack_public_path__ + "static/media/1280px-Git-logo.svg.c2f5c09e.png";